import Link from 'next/link'

import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'

import { usePortal } from '@/hooks/support/usePortal'

import Icon from '@/components/Icon'
import RowSkeleton from '@/components/skeletons/RowSkeleton'

const EXAMPLE_TOPICS = [
  {
    id: 1,
    icon: 'calendar-24',
    title: 'Аккаунт',
    slug: '',
    summary: 'bla-bla'
  },
  {
    id: 2,
    icon: 'calendar-24',
    title: 'Майнинг',
    slug: '',
    summary: 'bla-bla'
  },
  {
    id: 3,
    icon: 'calendar-24',
    title: 'Хешрейты',
    slug: '',
    summary: 'bla-bla'
  }
] // TODO: remove

const SupportPopularArticles = () => {
  const { articles, isLoading } = usePortal()

  const { popular } = articles || {}

  const popularArticles = !!popular?.length ? popular : EXAMPLE_TOPICS

  return (
    <div className="grid grid-cols-1 gap-3 tablet:grid-cols-2 tablet:gap-y-8 desktop:grid-cols-3 desktop:gap-x-5">
      {isLoading ? (
        <>
          {[...Array(3)].map((_, index) => (
            <RowSkeleton
              className="mb-5 h-[130px] w-full rounded-xl"
              key={index}
            />
          ))}
        </>
      ) : (
        <>
          {popularArticles?.map(({ id, title, slug, summary }, index) => (
            <div className="h-full" key={index}>
              <h3 className="text-x-md font-medium leading-x-md">{title}</h3>
              <div className="mt-1 text-x-base leading-x-base text-secondary-500">
                {summary}
              </div>
              <Link
                className={clsx(
                  'mt-5 flex items-center text-x-base font-medium leading-x-base',
                  'text-secondary-500 transition-all hover:text-gray-800 hover:opacity-90'
                )}
                href={{
                  pathname: '/support/[id]/[slug]',
                  query: { id, slug }
                }}
              >
                <span>
                  <FormattedMessage
                    {...{
                      id: 'support.more',
                      defaultMessage: 'Подробнее'
                    }}
                  />
                </span>
                <Icon
                  className="ml-1.5 h-4 w-4 flex-none"
                  name="chevron-right-16"
                />
              </Link>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default SupportPopularArticles
